import { Appointment } from "./routersConstants";

const config = {
  VERSION: process.env.VERSION,
};

export default config;

export const SERVER_API_URL = process.env.REACT_APP_SERVER_API_URL;
export const SOCKET_CONNECTION_URL = process.env.REACT_APP_SOCKET_CONNECTION_URL;/*CR #449 @Author Jithin Kuriakose @Date 18 June 2021*/
export const NODE_SERVER_URL = process.env.REACT_APP_NODE_SERVER_URL;/*CR #449 @Author Jithin Kuriakose @Date 18 June 2021*/

export const AUTHORITIES = {
  ADMIN: 'ROLE_ADMIN',
  USER: 'ROLE_USER',
};

export const messages = {
  DATA_ERROR_ALERT: 'Internal Error',
};

export const APP_DATE_FORMAT = 'DD/MM/YY HH:mm';
export const APP_TIMESTAMP_FORMAT = 'DD/MM/YY HH:mm:ss';
export const APP_LOCAL_DATE_FORMAT = 'MM/DD/YYYY';
export const APP_LOCAL_DATE_TIME_FORMAT = 'MM/DD/YYYY hh:mm A';
export const APP_LOCAL_DATE_FORMAT_FOR_INSURANCE_API = 'YYYY-MM-DD';/*CR #503 @Author Aby Joseph @Date 22 June 2021*/
export const APP_LOCAL_DATETIME_FORMAT = 'YYYY-MM-DDTHH:mm';
export const APP_LOCAL_DATETIME_FORMAT_Z = 'YYYY-MM-DDTHH:mm Z';
export const APP_WHOLE_NUMBER_FORMAT = '0,0';
export const APP_TWO_DIGITS_AFTER_POINT_NUMBER_FORMAT = '0,0.[00]';
export const APP_SERVER_DATE_FORMAT = 'YYYY-MM-DD';
export const APP_SERVER_DATETIME_FORMAT = 'YYYY-MM-DD HH:mm';/** Bug #758 - Implement filter option to select recipients for sending broadcast message @Author: Jithin Kuriakose @Date 03Mar2022 */
export const APP_LOCAL_DATE_FORMAT_HEALTH_RECORD = 'll';//'MMM DD YYYY'; /*CR #637 - For the date format like Oct 21, 2021 @Author Aby  @Date 21 Oct 2021*/
export const APP_LOCAL_DATE_FORMAT_APPOINTMENT = 'lll';//'MMM DD YYYY hh:mm A'; /*CR #601 @Author Akhil @Date 04 sept 2021*/
export const APP_LOCAL_DATE_FORMAT_INSURANCE = 'll';//'MMM DD YYYY hh:mm A'; /*CR #601- - For the date format like Sep 12, 2021 @Author Aby  @Date 12 sept 2021*/
export const APP_LOCAL_TIME_FORMAT_APPOINTMENT = 'hh:mm A'; /*CR #601 @Author Linda Susan Raju @Date 09 sept 2021*/
export const APP_LOCAL_TIME_FORMAT_EFFECTIVE_DATE = 'MM-DD-YYYY'; /*Bug #503 @Author Linda Susan Raju @Date 19 Oct 2021*/
export const APP_LOCAL_TIME_FORMAT_BROADCAST = 'DD MMMM YYYY hh:mm A'; /*Bug #758 @Author Liya @Date 17 Feb 2022*/
export const APP_DATE_OF_BIRTH = "DD MMM, YYYY"; //Bug 939 @Author Shaheel Navas
export const APP_LOCAL_DATE_FORMAT_LISTAPPOINTMENT = 'DD MMM, YYYY';/**  Bug #744 midhila Velayudhan Date 16 feb 2022 */
export const APP_LOCAL_DATETIME_FORMAT_SCHEDULE_BROADCAST = 'YYYY-MM-DDTHH:mm:ss';
export const ACTION_SERVICE_WORKER_UPDATED = 'ACTION-SERVICE-WORKER-UPDATED';
export const UPDATE_REFRESH_TIMER_IN_SEC = 5;

export const APP_LOCAL_TIME_FORMAT = 'hh:mm A';
export const APP_LOCAL_DATE_FORMAT_TYPE2 = 'DD MMM, YYYY';
export const APP_LOCAL_DATE_TIME_FORMAT_TYPE2 = 'DD MMM, YYYY hh:mm A';
export const APP_MESSAGE_LIST_DAY_MONTH = 'DD MMM';

/**Bug #1018 17 aug 2022 */
export const OPEN_COMPOSE = 'OPEN_COMPOSE';
export const OPEN_INBOX = 'OPEN_INBOX';
export const OPEN_OUTBOX = 'OPEN_OUTBOX';
export const OPEN_DRAFT = 'OPEN_DRAFT';
export const OPEN_STARRED = 'OPEN_STARRED';
export const FORWARD_MESSAGE = 'FORWARD_MESSAGE';
export const REPLY_MESSAGE = 'REPLY_MESSAGE';
/*bug #512 @Author AKhil MC @Date 26 July 2021*/
export const wordCapitalize = value => {
  if (!value) return "";
  value = value.toLowerCase();
  return value
    .split(" ")
    .map(val => val.charAt(0).toUpperCase() + val.slice(1))
    .join(" ");
};

// export const PatientDashboardPath = HealthRecord.path
export const AppointmentPath = Appointment.path
